<template>
    <div style="background-color: #fafafa;">
        <van-nav-bar title="设置搜索条件" left-text="返回" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
        <div class="skuDetailDiv">
            <grid class="form-box" v-model="data" :descriptions="descriptions"/>
        </div>
        <div class="recordBox">
            <van-button type="info" size="large" @click="search">搜索</van-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Tab, Tabs, Panel, Field, List,Search, Popup, PullRefresh, NavBar, Button,Toast} from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import Grid from "../../components/Grid";

    export default {
        data: function () {
            return {
                data: {},
                descriptions: [],
                type: 0
            }
        },
        components: {
            Grid,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh
        },
        created: function () {
            this.type = this.$route.query.type;
            this.getSkuInitInfo();
        },
        computed: {
            getRadCategory: function() {
                return this.data.radCategory;
            }
        },
        methods: {
            async getSkuInitInfo() {
                let resp = await dealerOrderService.getSearchInitInfo(this.type);
                if (resp.data.Status === "1"){
                    this.descriptions = resp.data.Data.descriptions;
                    this.data = resp.data.Data.data;
                }
            },
            async search(){
                Toast.loading({
                    duration:0,
                    message: '处理中...',
                    forbidClick: true,
                });
                let isEmpty = true;
                if(this.data.radCategory){
                    isEmpty = false;
                }
                if(this.data.radId){
                    isEmpty = false;
                }
                if(this.type == "parts"){
                    if(this.data.skuId){
                        isEmpty = false;
                    }
                }
                if(this.type == "main"){
                    if(this.data.pieces){
                        isEmpty = false;
                    }
                    if(this.data.centerCategory){
                        isEmpty = false;
                    }
                    if(this.data.centerSpacing){
                        isEmpty = false;
                    }
                    if(this.data.caliber){
                        isEmpty = false;
                    }
                    if(this.data.color){
                        isEmpty = false;
                    }
                    if(this.data.waterFlow){
                        isEmpty = false;
                    }
                    if(this.data.isSpecials){
                        isEmpty = false;
                    }
                    if(this.data.custom_text_1){
                        isEmpty = false;
                    }
                    if(this.data.custom_text_4){
                        isEmpty = false;
                    }
                    if(this.data.custom_text_2){
                        isEmpty = false;
                    }
                    if(this.data.custom_text_3){
                        isEmpty = false;
                    }
                    if(this.data.custom_dropdown_2){
                        isEmpty = false;
                    }
                }
                if(isEmpty){
                    Toast.clear();
                    Toast.fail("请至少设置一个搜索条件！");
                    return;
                }
                Toast.clear();
                this.data.type = this.type;
                this.$router.push({path:"invIndex",  query: this.data} );
            },
            onClickLeft(){
                this.$router.go(-1);
            },
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 0;
    }
    .card p {
        margin:10px 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .recordBox {
        padding: 0.5rem 0;
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:0;
        position:fixed;
        width: 100%;
    }
    .skuDetailDiv{
        width:100%;
        margin:0 auto;
        overflow: hidden;
        padding-bottom: 150px;
    }
</style>